<template>
  <WsUpdate
    :modelName="modelName"
    :id="$route.params.id"
    :label="label"
    :fields="_fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
    :customUpdateAction="customUpdateAction"
    titleKey="name"
  >
  </WsUpdate>
</template>

<script>
import model from "@/models/admin";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    customUpdateAction: (modelData) => {
      if (!modelData.password) {
        delete modelData.password;
      }
    },
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "管理者資訊",
              fields: [
                "sequence",
                "name",
                "email",
                "password",
                "roles",
                "scopes",
              ],
            },
          ],
        },
      ],
      secondary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "啟用設定",
              remark: "停用的管理者將無法使用管理後台介面",
              fields: ["is_active"],
            },
          ],
        },
      ],
    },
  }),
  computed: {
    _fields() {
      let _fields = { ...this.fields };
      _fields.password.rules = "min:6|nospace";
      return _fields;
    },
  },
};
</script>